import { render, staticRenderFns } from "./SlideImage.vue?vue&type=template&id=5cb30ef8&scoped=true&"
import script from "./SlideImage.vue?vue&type=script&lang=ts&"
export * from "./SlideImage.vue?vue&type=script&lang=ts&"
import style0 from "./SlideImage.vue?vue&type=style&index=0&id=5cb30ef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb30ef8",
  null
  
)

export default component.exports